﻿import { ajaxPost } from '../../utils/ajax';
import { required, alpha, minLength, between, email, sameAs, maxLength, numeric, withParams } from 'vuelidate/lib/validators';
import { mapGetters, mapState } from 'vuex';
import checkoutService from '../../api/checkout';

const nameCheck = value => {
    if (typeof value === 'undefined' || value === null || value === '') {
        return true;
    }
    return /^[^0-9<>(){}\[\]/\\|½@$£€§#%+=*?!&.,]{2,}$/.test(value);
}

export default {
    name: 'personal-details',
    template: '#personal-details-template',
    created() {
    },
    mounted() {
        this.$watch('$v.model.$invalid',
            () => {
                this.updateValidState();
            });
        this.updateValidState();
        this.model = this.viewmodel;
        if (this.model.clientRefresh) {
            this.$v.model.$touch();
        }
        this.$store.watch(state => state.checkout.customer, (res) => { this.updateCustomerValues(res) });
    },
    props: ['viewmodel', 'blockid'],
    data: () => ({
        model: {
            billingAddress: {
            },
            confirmEmail: "",
            clientRefresh: false
        },
        showShippingAddressModal: false,
    }),
    computed:
    Object.assign(
        mapState({
            existingCustomerBlockActive: state => state.checkout.existingCustomerBlockActive,
            customerDataValidated: state => state.checkout.customerDataValidated,
            existingCustomer: state => state.checkout.customer.existingCustomer
        }),
        {

        }
    ),
    validations: {
        model: {
            billingAddress: {
                givenName: {
                    required,
                    nameCheck,
                    minLength: minLength(2),
                    maxLength: maxLength(63),
                },
                surname: {
                    required,
                    nameCheck,
                    minLength: minLength(2),
                    maxLength: maxLength(63)
                },
                mobileNumber: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(8),
                    numeric
                },
                landlineNumber: {
                    minLength: minLength(8),
                    maxLength: maxLength(8),
                    numeric
                },
                streetName: {
                    required,
                    maxLength: maxLength(80)
                },
                streetNumber: {
                    required
                },
                floorNumber: {
                    maxLength: maxLength(3)
                },
                postCode: {
                    required,
                    numeric,
                    minLength: minLength(4),
                    maxLength: maxLength(4)
                },
                city: {
                    required,
                    maxLength: maxLength(63)
                },
                floorSide: {
                    maxLength: maxLength(10)
                },
                email: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(53),
                    email
                },
            },
            confirmEmail: {
                required,
                sameAsEmail: sameAs(function (arg) {
                    return this.model.billingAddress.email;
                })
            },
        }
    },
    methods: {
        customerChangedData()
        {
            if(this.existingCustomer)
            {
                checkoutService.saveInfo(this.viewmodel.existingCustomerChangedDataUrl);
            }
        },
        toggleModal() {
            this.showShippingAddressModal = !this.showShippingAddressModal;
        },
        updateValidState() {
            this.$store.dispatch('updateValidState', { invalid: this.$v.model.$invalid, blockId: this.blockid });
        },
        updateCustomerValues(res) {
            this.model.billingAddress.givenName = res.firstName;
            this.model.billingAddress.surname = res.lastName;
            this.model.billingAddress.streetName = res.street;
            this.model.billingAddress.streetNumber = res.houseNumber + res.houseLetter;
            this.model.billingAddress.surName = res.lastName;
            this.model.billingAddress.floorNumber = res.floor;
            this.model.billingAddress.floorSide = res.door;
            this.model.billingAddress.city = res.city;
            this.model.billingAddress.postCode = res.zipCode;
            this.model.billingAddress.email = res.email;
            this.model.confirmEmail = res.emailConfirmed;
            this.model.billingAddress.mobileNumber = res.mobilePhone;
        }
    },
    ready: function () {
        document.addEventListener("keydown",
            (e) => {
                if (this.showShippingAddressModal && e.keyCode === 27) {
                    this.toggleModal();
                }
            });
    }
}
